import { GetServerSideProps, NextPage } from "next";
import { Button } from "@mui/material";
import { ProductListings as ProductListingsComponent } from "../../src/templates";

import { TransformedFilterEntity } from "../../types/transformedFilterEntity";
import { TransformedProductEntity } from "../../types/transformed_product_entity";
import { ProductListings } from "../../src/services";
import { SEO } from "../../src/atoms";
import { useRouter } from "next/router";

interface Props {
  count: number;
  products: TransformedProductEntity[];
  filters: TransformedFilterEntity[];
  seo?: any;
  sortBy: string;
  title: string;
  eventId: string;
  banners: {
    desktop: null | string;
    mobile: null | string;
  };
}
const Collection: NextPage<Props> = props => {
  const router = useRouter();
  const { count, products, filters, seo, sortBy, eventId, banners } = props;

  return (
    <div className="min-h-screen">
      {seo && <SEO seo={seo} />}
      {products.length > 0 ? (
        <ProductListingsComponent
          eventId={eventId}
          title={props.title}
          count={count}
          products={products}
          filters={filters}
          sortBy={sortBy}
          banners={banners}
        />
      ) : (
        <div className="flex justify-center items-center">
          <div className="p-3 bg-gray-50 space-y-4 rounded-md ">
            <div className="space-y-1">
              <div className="flex gap-2 items-center text-xl">
                <p className="sectionTitle text-lg">No products found.</p>
              </div>
              <p className="text-gray-500 text-sm">
                Please try again with different filter combination.
              </p>
            </div>
            <a className="block">
              <Button
                fullWidth
                variant="contained"
                onClick={() => router.back()}>
                Go Back
              </Button>
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export const getServerSideProps: GetServerSideProps = async context => {
  const { query, res } = context;
  let url = `${process.env.BASE_URL}/listings/items/collections?collectionHandle=${query.id}&limit=24`;
  Object.keys(query).forEach(key => {
    if (query[key]) {
      url += `&${key}=${query[key]}`;
    }
  });
  const props = await ProductListings.getProducts(url);
  res.setHeader(
    "Cache-Control",
    "public, s-maxage=300, stale-while-revalidate=59"
  );

  return {
    props,
  };
};

export default Collection;
